import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6197f93b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/components/wechat/css/wechat.less?vue&type=style&index=0&id=6197f93b&prod&lang=less&scoped=true&external"
import style1 from "@/components/wechat/css/wechat.scss?vue&type=style&index=1&id=6197f93b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6197f93b",
  null
  
)

export default component.exports